import { getApi } from "@/api";
import { track } from "@/analytics/analytics";

/**
 * Start Stripe Checkout for a report. The BFF owns all Stripe secret logic; this
 * just asks for a session URL and redirects the browser to it.
 *
 * @param returnOrigin App origin for Stripe success/cancel redirects (defaults to current page).
 *   Embedded widgets pass the script origin so buyers return to the standalone preview route.
 */
export async function startCheckout(
  reportId: string,
  offerId: string,
  returnOrigin: string = window.location.origin,
): Promise<void> {
  const api = getApi();
  const origin = returnOrigin.replace(/\/$/, "");
  track("checkout_started", { reportId, offerId });
  const { checkoutUrl } = await api.createCheckoutSession({
    reportId,
    offerId,
    successUrl: `${origin}/${encodeURIComponent(offerId)}/preview/${encodeURIComponent(reportId)}?session_id={CHECKOUT_SESSION_ID}`,
    cancelUrl: `${origin}/${encodeURIComponent(offerId)}/preview/${encodeURIComponent(reportId)}`,
  });
  window.location.href = checkoutUrl;
}
